import { useTranslation } from 'react-i18next';

/**
 * Takes a raw, unvalidated `insight_type` string from StarRocks, so an unmapped type
 * (e.g. `ChurnWarningV2WebCategory`) resolves to `undefined` rather than a raw label.
 */
export function useInsightTypeLabel(): (insightType: string) => string | undefined {
    const { t } = useTranslation('customers-list');

    return (insightType) => {
        switch (insightType) {
            case 'XSellWebCategory':
                return t('insight_type__cross_sell');
            case 'ChurnWarningWebCategory':
                return t('insight_type__churn_warning');
            case 'GlobalChurnWarning':
                return t('insight_type__global_churn_warning');
            case 'FirstPurchaseWebCat3':
                return t('insight_type__first_purchase');
            case 'ShareOfWalletCategory':
                return t('insight_type__share_of_wallet');
            case 'PreviouslyPurchasedCategory':
                return t('insight_type__previously_purchased');
            case 'IndustryTopCategory':
                return t('insight_type__industry_top');
            case 'GlobalTopCategory':
                return t('insight_type__global_top');
            default:
                return undefined;
        }
    };
}
